import { render, staticRenderFns } from "./ChangeTournamentMatchForms.vue?vue&type=template&id=2a42a742&scoped=true"
import script from "./ChangeTournamentMatchForms.vue?vue&type=script&lang=js"
export * from "./ChangeTournamentMatchForms.vue?vue&type=script&lang=js"
import style0 from "./ChangeTournamentMatchForms.vue?vue&type=style&index=0&id=2a42a742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a42a742",
  null
  
)

export default component.exports